import React from 'react';
import styled from 'styled-components'
import {Flex} from 'rebass';
import PropTypes from 'prop-types';

import {bottom, boxShadow, display, left, minHeight, position, right, top, zIndex} from 'styled-system'


const StyledFlex = styled(Flex)`
  ${position}
  ${display}
  ${top}
  ${right}
  ${bottom}
  ${left}
  ${boxShadow}
  ${zIndex}
  ${minHeight}
  z-index: 9200;
`;

const Toolbar = ({children, bg, color, ...rest}) => {
	return (
		<StyledFlex m={0} color={color} bg={bg} {...rest}>
			{children}
		</StyledFlex>
	);
};


Toolbar.propTypes = {
	bg: PropTypes.string,
	color: PropTypes.string,
	children: PropTypes.node
};

Toolbar.defaultProps = {
	bg: 'gray',
	color: '#fff'
};

export default Toolbar;
